'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssetPublishedDateMessage = exports.getAssetType = exports.formatAssetPublishedData = undefined;
exports.commaFormatted = commaFormatted;
exports.percentFormatted = percentFormatted;
exports.percentFormatted1dp = percentFormatted1dp;
exports.countFormat = countFormat;
exports.ierFormat = ierFormat;
exports.ierFormat2DP = ierFormat2DP;
exports.priceFormatted = priceFormatted;
exports.emvTotalPriceFormatted = emvTotalPriceFormatted;
exports.scientificFormatted = scientificFormatted;
exports.paidReportFormat = paidReportFormat;
exports.getGraphLabelFormatting = getGraphLabelFormatting;
exports.getGraphLabelPercentageFormatting = getGraphLabelPercentageFormatting;
exports.sciFormatted = sciFormatted;

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatAssetPublishedData = exports.formatAssetPublishedData = function formatAssetPublishedData(post) {
  var publishedDate = _lodash2.default.get(post.trackedAsset, 'publishedDate', null) || post.publishedDate;
  return (0, _moment2.default)(publishedDate).format('YYYY-MM-DD');
};

var getAssetType = exports.getAssetType = function getAssetType(post) {
  if (post.isIGTV) return 'IGTV';
  if (post.isReel) return 'REEL';
  if (post.isVideo || _lodash2.default.get(post, 'trackedAsset.assetType', '') === 'VIDEO') return 'video';
  if (post.isCarousel || _lodash2.default.get(post, 'trackedAsset.assetType', '') === 'CAROUSEL') return 'carousel';
  if (post.type === 'stories' || post.isStory || _lodash2.default.get(post, 'trackedAsset.assetType', '') === 'STORY') return 'story';
  if (_lodash2.default.get(post, 'assetType') === 'TEXT') return 'post';

  return 'image';
};

var TELEGRAM = 'TELEGRAM';

var getPlatform = function getPlatform(post, isTelegram) {
  if (isTelegram) return TELEGRAM;
  return post.trackedAsset ? _lodash2.default.get(post, 'trackedAsset.platform') : _lodash2.default.get(post, 'platform');
};

var getAssetPublishedDateMessage = exports.getAssetPublishedDateMessage = function getAssetPublishedDateMessage(post) {
  var isTelegram = post.assetURL && post.assetURL.match(/\/\/t.me\//i);
  var DEFAULT_PLATFORM = 'Instagram';
  var platform = getPlatform(post, isTelegram);
  var assetType = isTelegram ? 'message' : getAssetType(post);
  var date = post.trackedAsset ? post.trackedAsset.publishedDate : post.publishedDate;
  var msg = _lodash2.default.capitalize(platform || DEFAULT_PLATFORM) + ' ' + assetType + ' ';
  msg += 'posted at ' + (0, _moment2.default)(date).format('LT') + ' on ' + formatAssetPublishedData(post);
  return msg;
};

function commaFormatted(number) {
  var de = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  return number ? (0, _numeral2.default)(number).format('0,0') : de;
}

function percentFormatted(number) {
  return (0, _numeral2.default)(number).format('0.00');
}

function percentFormatted1dp(number) {
  return (0, _numeral2.default)(number).format('0.0');
}

function countFormat() {
  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var numberFormat = number > 1000000 ? '0.0a' : '0a';
  return (0, _numeral2.default)(number).format(numberFormat);
}

function ierFormat(num) {
  return (0, _numeral2.default)(num).format('0.0');
}

function ierFormat2DP(num) {
  return (0, _numeral2.default)(num).format('0.00');
}

function priceFormatted(number) {
  return (0, _numeral2.default)(number).format('0,0[.]00');
}

function emvTotalPriceFormatted(number) {
  return (0, _numeral2.default)(number).format('0,0');
}

function scientificFormatted(number) {
  var format = number > 1000000 ? '0.00a' : '0.0a';
  return (0, _numeral2.default)(number).format(format);
}

function paidReportFormat(number) {
  if (!number) return '-';
  var format = number > 1000000 || number < 100000 && number > 1000 ? '0.0a' : '0,0a';
  return (0, _numeral2.default)(number).format(format);
}

function getGraphLabelFormatting(tooltipItem, data) {
  var label = data.labels[tooltipItem.index];
  var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
  return label + ' - ' + commaFormatted(datasetLabel);
}

function getGraphLabelPercentageFormatting(tooltipItem, data) {
  var label = data.labels[tooltipItem.index];
  var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
  return label + ' - ' + commaFormatted(datasetLabel) + ' %';
}

function sciFormatted(number) {
  var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

  if (!number) return def;
  var format = number > 1000 ? '0.0a' : '0';
  format = number > 1000000 ? '0.0a' : format;
  return (0, _numeral2.default)(number).format(format);
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/utils/formatting.js
 ** module id = 52
 ** module chunks = 0
 **/